import React from "react";
import { Autocomplete, Box, Grid, IconButton, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import CloseIcon from "@mui/icons-material/Close";
import { MenuItem } from "@mui/material";
import { errorMessage, errorMessage2 } from "app/utils/utils";

const AdminComplianceHeader = ({
  employeeList,
  search,
  setSearch,
  setPage,
  complienceStatus,
  setComplienceStatus,
  suggestions,
  setDisableButton,
  setMonth,
  setDate,
  date,
  month,
  setEmpId,
  setError2,
  setError,
  today,
  handleMonthYearChange,
  handleOnlyDateChange,
  monthDateFormate,
  error,
  error2,
  exportAction,
  resetAction,
    employeeType,
  setEmployeeType,
  statusFilter,
  setStatusFilter,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" },
      }}
    >

      <Grid container spacing={2} sx={{ mx: "auto", mb: 2 }} columnGap={2}>
        {/* Employee Type filter */}
        {employeeList ? (
          <Grid item lg={2} md={2} sm={12} xs={12} sx={{ mt: 0 }}>
            <Autocomplete
              value={search}
              id="EMPName"
              getOptionLabel={(employeeList) => {
                if (employeeList.firstName) {
                  return employeeList.firstName;
                } else {
                  return employeeList;
                }
              }}
              options={employeeList}
              renderOption={(props, option) => {
                return (
                  <li {...props} key={`${option.firstName}+${option.userId}`}>
                    {option.firstName}
                  </li>
                );
              }}
              onChange={(event, val) => {
                if (val === null) {
                  setSearch(null);
                } else {
                  const { userId, firstName } = val || {};
                  setPage(0);
                  setSearch(firstName);
                  setEmpId(userId);
                  setDisableButton(false);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Employee Name"
                  variant="standard"
                />
              )}
            />
          </Grid>
        ) : (
          ""
        )}
        {/* Status filter for attendance report only */}
{statusFilter !== undefined && setStatusFilter !== undefined && (
  <Grid item lg={2} md={2} sm={12} xs={12} sx={{ mt: 0 }}>
    <TextField
      select
      label="Status"
      size="small"
      variant="standard"
      value={statusFilter}
      onChange={(e) => {
        setStatusFilter(e.target.value);
        setPage(0);
      }}
      sx={{ width: "100%" }}
      InputProps={{
        endAdornment: (
          <>
            {statusFilter && (
              <IconButton
                aria-label="clear"
                onClick={(e) => {
                  e.stopPropagation();
                  setStatusFilter("");
                  setPage(0);
                }}
                size="small"
                sx={{
                  mr: "-14px", // pushed more right
                  p: 0,
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            )}
          </>
        )
      }}
    >
      <MenuItem value="Leave">Leave</MenuItem>
      <MenuItem value="Present">Present</MenuItem>
      <MenuItem value="Half-Day">Half-Day</MenuItem>
      <MenuItem value="Absent">Absent</MenuItem>
    </TextField>
  </Grid>
)}


        {suggestions ? (
          <Grid item lg={2} md={2} sm={12} xs={12} sx={{ mt: 0 }}>
            <Autocomplete
              value={complienceStatus}
              options={suggestions}
              getOptionLabel={(option) => {
                if (option.label) {
                  return option.label;
                } else {
                  return option;
                }
              }}
              renderOption={(props, option) => {
                return (
                  <li {...props} key={`${option.label}`}>
                    {option.label}
                  </li>
                );
              }}
              name="work_mode"
              onChange={(e, v) => {
                setComplienceStatus(v?.label);
                setDisableButton(false);
                setPage(0);
              }}
              renderInput={(params) => {
                return (
                  <TextField
                    {...params}
                    label="Compliance Status"
                    variant="standard"
                    fullWidth
                  />
                );
              }}
            />
          </Grid>
        ) : (
          ""
        )}

        <Grid item lg={2} md={2} sm={12} xs={12} sx={{ mt: 0 }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              format="dd/MM/yyyy"
              value={!!date ? new Date(date) : null}
              label="Date"
              openTo="day"
              views={["year", "month", "day"]}
              onError={(newError) => {
                if (newError === "invalidDate") {
                  setDisableButton(true);
                } else {
                  if (newError === null) {
                    setDisableButton(false);
                  }
                }
                setError(newError);
              }}
              slotProps={{
                textField: {
                  variant: "standard",
                  helperText: errorMessage(error),
                  onChange: (newVal, validate) => {
                    const { validationError } = validate || {};
                    validationError ? setError(validationError) : setError("");
                    handleOnlyDateChange(newVal);
                  },
                },
              }}
              onAccept={(newVal) => {
                handleOnlyDateChange(newVal);
              }}
              maxDate={today.setDate(today.getDate() - 1)}
            />
          </LocalizationProvider>
          {!!date && date !== monthDateFormate && (
            <IconButton
              aria-label="close"
              onClick={() => {
                setDate(monthDateFormate);
              }}
              sx={{
                position: "absolute",
                pt: "19px",
                // color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </Grid>

        <Grid item lg={2} md={2} sm={12} xs={12} sx={{ mt: 0 }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              format="MM/yyyy"
              value={!!month ? new Date(month) : null}
              label={"Month and Year"}
              views={["year", "month"]}
              openTo="month"
              onError={(newError) => {
                if (newError === "invalidDate") {
                  setDisableButton(true);
                } else {
                  if (newError === null) {
                    setDisableButton(false);
                  }
                }
                setError2(newError);
              }}
              slotProps={{
                textField: {
                  variant: "standard",
                  helperText: errorMessage2(error2),
                  error: !!error2 ? true : false,
                  onChange: (newVal, validate) => {
                    const { validationError } = validate || {};
                    validationError
                      ? setError2(validationError)
                      : setError2("");
                    handleMonthYearChange(newVal);
                  },
                },
              }}
              onAccept={(newVal) => {
                handleMonthYearChange(newVal);
              }}
              maxDate={new Date()}
            />
          </LocalizationProvider>
          {!!month && (
            <IconButton
              aria-label="close"
              onClick={() => {
                setMonth(null);
                setDate(monthDateFormate);
              }}
              sx={{
                position: "absolute",
                pt: "19px",
                // color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </Grid>

        <Grid
          item
          lg={3}
          md={3}
          sm={12}
          xs={12}
          sx={{ mt: 0, justifyContent: "space-between" }}
          columnGap={1}
        >
          <Grid container>
            {exportAction ? (
              <Grid item xs={12} sm={12} lg={6} md={6}>
                {exportAction}
              </Grid>
            ) : (
              ""
            )}
            {resetAction ? (
              <Grid item xs={12} sm={12} lg={6} md={6}>
                {resetAction}
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminComplianceHeader;